<template>
  <div class="images-wrapper">
    <div class="images" :class="gridClass">
      <img
          v-for="(src, index) in images"
          :src="fullSrc(src)"
          :key="index"
          :class="getCornerClass(index, images.length)"
          alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageGrid',
  props: {
    images: {
      type: Array,
      required: true
    },
    imgDomain: {
      type: String,
      required: true
    }
  },
  computed: {
    gridClass() {
      const len = this.images.length;
      if (len === 2) return 'grid-1x2';
      const side = Math.ceil(Math.sqrt(len));
      return `grid-${side}`;
    }
  },
  methods: {
    fullSrc(src) {
      return `${this.imgDomain}/${src}`;
    },
    getCornerClass(index, total) {
      const side = Math.ceil(Math.sqrt(total));
      if (!Number.isInteger(side)) return '';

      if (index === 0) return 'top-left';
      if (index === side - 1) return 'top-right';
      if (index === total - side) return 'bottom-left';
      if (index === total - 1) return 'bottom-right';
      return '';
    }
  }
}
</script>

<style lang="scss" scoped>
.images-wrapper {
  overflow: hidden;
  border-radius: 8px;
  width: 288px;
  height: 288px;
  background: #f7f7f7;
}

.images {
  display: grid;
  gap: 0;               /* убираем все отступы между картинками */
  height: 100%;
  grid-auto-rows: 1fr;  /* равные по высоте ряды */
}

/* Специально для двух картинок */
.images.grid-1x2 {
  grid-template-columns: 1fr;
}

/* Первая картинка: скругляем только верхние углы */
.images.grid-1x2 img:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

/* Вторая картинка: скругляем только нижние углы */
.images.grid-1x2 img:last-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

/* Обычные сетки для 1–6 картинок */
.images.grid-1 {
  grid-template-columns: repeat(1, 1fr);
}
.images.grid-2 {
  grid-template-columns: repeat(2, 1fr);
}
.images.grid-3 {
  grid-template-columns: repeat(3, 1fr);
}
.images.grid-4 {
  grid-template-columns: repeat(4, 1fr);
}
.images.grid-5 {
  grid-template-columns: repeat(5, 1fr);
}
.images.grid-6 {
  grid-template-columns: repeat(6, 1fr);
}

.images img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: auto;  /* отключаем фиксированный aspect-ratio */
  display: block;
}
</style>


